<template>
  <div>
    <div class="ui inverted segment">
      <h2 class="ui header">
        <i class="envelope icon" />
        {{ localisation.consent.consentTitle }}
      </h2>
      <p>{{ localisation.consent.consentBody }}</p>
      <button class=" ui fluid tertiary circular button" @click="attemptAgree" :disabled="isLoading">
        <i class="ui check icon" />{{ localisation.generic.agree }}
      </button>
      <br>
      <button class=" ui fluid tertiary circular button" @click="attemptDecline" :disabled="isLoading">
        <i class="ui x icon" />{{ localisation.generic.disagree }}
      </button>

      <div v-if="isLoading" style="text-align: center; margin: 1rem 0"><i class="ui spinner loading icon"/></div>
      <error-messages v-if="hasError" :errors="errorMessages"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ErrorMessages from '../components/ErrorMessages'
import { mapActions } from 'vuex'

export default {
  name: 'RequestConsent',
  components: {
    ErrorMessages
  },
  data () {
    return {
      hasError: false,
      errorMessages: [],
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['matchUserToStudy', 'updateBrazeConsent', 'declineConsent']),

    attemptAgree () {
      this.hasError = false
      this.errorMessages = []
      this.isLoading = true
      this.matchUserToStudy(true).then(() => {
        this.updateBrazeConsent(true).then(() => {
        }).catch((error) => {
          console.log(error)
          Vue.Rollbar.error('Updating Braze attributes failed', error)
        })
        this.isLoading = false
        this.$router.push({ name: 'Manage' })
      }).catch((error) => {
        console.log(error)
        this.isLoading = false
        this.hasError = true
        this.errorMessages.push('genericMessage')
      })
    },
    attemptDecline () {
      this.hasError = false
      this.errorMessages = []
      this.isLoading = true
      this.declineConsent().then(() => {
        this.isLoading = false
        this.$router.push({ name: 'Login' })
      }).catch((error) => {
        console.log(error)
        this.isLoading = false
        this.hasError = true
        this.errorMessages.push('genericMessage')
      })
    }
  },
  created () {
  }
}

</script>

<style scoped>
</style>
